import { Step } from 'react-joyride';

export const scenariosTourSteps: Step[] = [
  {
    target: '[data-tour="scenario-folder-tree"]',
    content: 'Test Scenarios are organized in a folder tree. Select a folder here to see its scenarios.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="create-subfolder-btn"]',
    content: 'Create a subfolder to organize scenarios for a feature, module, or sprint.',
  },
  {
    target: '[data-tour="create-scenario-btn"]',
    content: 'Click here to write a new Test Scenario in the selected folder.',
  },
  {
    target: '[data-tour="import-excel-btn"]',
    content: 'Already have scenarios in Excel? Import them here instead of typing everything manually.',
  },
  {
    target: '[data-tour="bulk-edit-btn"]',
    content: 'Select 2 or more scenarios using the checkboxes, then use Bulk Edit to change Priority, Environment, or Tags across all of them at once.',
  },
  {
    target: '[data-tour="export-btn"]',
    content: 'Select scenarios and click Export to download them as an Excel file.',
  },
  {
    target: '[data-tour="create-test-run-btn"]',
    content: 'Ready to execute? Create a Test Run directly from the approved folder here.',
  },
];

export const testCasesTourSteps: Step[] = [
  {
    target: '[data-tour="testcase-folder-tree"]',
    content: 'Test Cases live in their own folder tree, separate from Test Scenarios. Select a subfolder to see its test cases.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="create-subfolder-btn"]',
    content: 'Create a subfolder to organize test cases for a feature, module, or sprint.',
  },
  {
    target: '[data-tour="create-testcase-btn"]',
    content: 'Click here to add a new Test Case — Description, Preconditions, Steps, Expected Result, Priority, and Tags.',
  },
  {
    target: '[data-tour="import-btn"]',
    content: 'Import test cases from an Excel (.xlsx) file or a TestRail XML export — the XML importer even recreates the folder structure for you.',
  },
  {
    target: '[data-tour="bulk-edit-btn"]',
    content: 'Select 2 or more test cases using the checkboxes, then use Bulk Edit to change Priority and/or Tags across all of them at once.',
  },
  {
    target: '[data-tour="export-btn"]',
    content: 'Select one or more test cases and click Export to download them as an Excel file.',
  },
  {
    target: '[data-tour="create-test-run-btn"]',
    content: 'Ready to execute? Create a Test Run directly from the approved folder here.',
  },
];

export const testRunsTourSteps: Step[] = [
  {
    target: '.ctr-title',
    content: 'This form creates a Test Run — a manual execution session against a folder of test cases or scenarios. You can also get here via the "Create Test Run" button on Test Cases or Test Scenarios.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="test-run-project-folder"]',
    content: 'Pick whether you\'re running Test Cases or Test Scenarios, then choose the project.',
  },
  {
    target: '[data-tour="test-run-source-folder"]',
    content: 'Choose the specific subfolder to execute. Only Approved folders can be selected — that\'s the peer-review gate at work.',
  },
  {
    target: '[data-tour="test-run-environment"]',
    content: 'Choose the environment this run targets — Stage, Preprod, or Production.',
  },
  {
    target: '[data-tour="test-run-cycle-label"]',
    content: 'Group related runs across environments under the same Cycle Label so you can track a release across Stage, Preprod, and Prod together.',
  },
  {
    target: '[data-tour="test-run-submit-btn"]',
    content: 'Create the run, then open it to start executing — set each item to Pass, Fail, or Blocked and attach evidence as you go.',
  },
];

export const testRunExecuteTourSteps: Step[] = [
  {
    target: '[data-tour="test-run-lifecycle-actions"]',
    content: 'Start Execution moves the run to In Progress. Sync New pulls in scenarios/test cases created after the run was created. Close Test Run locks it and makes it immutable.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="test-run-status-col"]',
    content: 'Each row shows the current result for one test case or scenario — Pass, Fail, Blocked, or Not Run.',
  },
  {
    target: '[data-tour="test-run-execute-btn"]',
    content: 'Click Execute (or Re-execute) to open the execution panel: set the result, add a comment or defect reference, and upload evidence.',
  },
  {
    target: '[data-tour="test-run-bulk-evidence-btn"]',
    content: 'Select multiple rows with these checkboxes, then use "Upload Evidence to Selected" to mark them all Pass and attach evidence in one go — handy for large regression runs.',
  },
];

export const foldersTourSteps: Step[] = [
  {
    target: '[data-tour="scenario-folder-tree"], [data-tour="testcase-folder-tree"]',
    content: 'Right-click any folder in the tree to Create a Subfolder, Rename, Move, Submit for Review, or Delete it.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="create-subfolder-btn"]',
    content: 'You can also create a subfolder from the action bar once a parent folder is selected.',
  },
  {
    target: '[data-tour="share-link-btn"]',
    content: 'Generate a shareable link for a folder — recipients are taken directly to that folder\'s content.',
  },
];
